<template>
    <v-dialog
        v-model="$store.state.audit.show"
        width="1200px"
    >
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="primary" dense>
                <v-spacer></v-spacer>    
                <h3>Show Logs</h3> 
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.audit.show = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <div  v-for="(itm ,idx) in data" :key="idx" >
                        <table dense v-if="itm.show"  class="tblLogs">
                        <thead>
                            <tr v-if="report">
                                <th colspan="4">{{ itm.ShiftDetail+ "/" +   itm.subject_id }}</th>
                            </tr>
                            <tr>
                                <th class="text-center" width="25%">{{ itm.name }}</th>
                                <th class="text-center" width="25%">{{ itm.email }}</th>
                                <th class="text-center" width="25%">{{ itm.description }}</th>
                                <th class="text-center" width="25%">{{ itm.updated_at }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="background: #fff;">
                                <td v-for="title in itm.properties.old.oldnames" :key="title"><b>{{ title }}</b></td>
                            </tr>
                            <tr style="background: #fff;">
                                <td v-for="(value, i) in itm.properties.old.olds" :key="i">{{  value == null ? 'Null': value }}</td>
                            </tr>
                            <tr style="background: #ebf3fd;">
                                <td v-for="title in itm.properties.attributes.attributenames" :key="title"><b>{{ title }}</b></td>
                            </tr>
                            <tr style="background: #ebf3fd;">
                                <td v-for="(value, i) in itm.properties.attributes.attribute" :key="i">{{ value }}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                    </div>
            </v-container>
        </v-card>
    </v-container>
    </v-dialog>
</template>
<script>
export default {
    props:['data','report'],
    data: function() {
        return {
        };
    },
    async mounted() {
        await this.data.forEach(async ele => {
                        ele.properties = JSON.parse(ele.properties)
                        var olds = [];var oldnames = [];var attribute = [];var attributenames = [];
                            for (const key in ele.properties.old) {
                                olds.push(ele.properties.old[key]);
                                oldnames.push(key);
                            }

                            for (const key in ele.properties.attributes) {
                                attribute.push(ele.properties.attributes[key]);
                                attributenames.push(key);
                            }
                            ele.properties = {
                                old :{
                                    olds,oldnames
                                }
                                ,
                                attributes:{
                                    attribute,attributenames
                                }
                            }
                    });
        console.log(this.data);
    }
};
</script>
<style>
.tblLogs{
    width: 100%;
}
</style>